var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoConvocatoria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_convocatoria",
    transform: "translate(0 -0.199)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6451",
    "data-name": "Rectangle 6451",
    width: 38,
    height: 38,
    transform: "translate(0 0.199)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20409",
    "data-name": "Path 20409",
    d: "M112.99,112.6h-1.3V101.433a1.445,1.445,0,0,0-2.28-1.14,28.89,28.89,0,0,1-17.783,6.042h-4.9c-4.559,0-8.321,3.42-8.321,7.751a7.945,7.945,0,0,0,7.067,7.637l3.876,9.12a3.832,3.832,0,0,0,2.166,2.051,3.638,3.638,0,0,0,1.6.342,5.16,5.16,0,0,0,1.824-.342,4.342,4.342,0,0,0,2.394-5.471l-2.28-5.358a29.3,29.3,0,0,1,14.363,5.586,1.294,1.294,0,0,0,.912.342,1.447,1.447,0,0,0,.684-.114,1.4,1.4,0,0,0,.8-1.254V115.453h1.3c.8,0,1.075-.684,1.075-1.482s-.392-1.368-1.19-1.368ZM94.7,128.562a1.414,1.414,0,0,1-.912,1.709,1.035,1.035,0,0,1-1.14,0,.937.937,0,0,1-.57-.57l-3.42-7.866h3.192Zm14.249-4.673A32.292,32.292,0,0,0,92.993,119.1h-6.27c-3.078,0-5.471-2.166-5.471-4.9s2.508-4.9,5.471-4.9h4.9a32.007,32.007,0,0,0,17.213-5.016v19.606Z",
    transform: "translate(-76.891 -97.903)",
    fill: "#27a2f1",
    stroke: "#27a2f1",
    strokeWidth: 0.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoConvocatoria);
export default __webpack_public_path__ + "static/media/ico_convocatoria.27ca881635224a1e894e1e3529065500.svg";
export { ForwardRef as ReactComponent };